import type { ReactNode } from 'react';
import { isNative } from '../../lib/platform';

// Routes rendered outside of `MobileLayout` (e.g. StoreList, CreateStore)
// don't have a built-in scroll container. On native the body is locked to
// the WebView to suppress iOS rubber-banding, so any content past 100vh on
// these screens would be clipped with no way to reach it. This wrapper adds
// a screen-height scroller on native; on web it's a no-op so the page keeps
// its normal body-scroll behaviour.
export function NativeScroll({ children }: { children: ReactNode }) {
  if (!isNative) return <>{children}</>;
  return (
    <div
      className="h-screen overflow-y-auto overflow-x-hidden overscroll-contain"
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {children}
    </div>
  );
}
